export const USimStatus = {
  PENDING_PROCESSING: "10",
  COMPLETE: "20",
  CANCELLED: "30",
} as const;

export type USimStatusValue = typeof USimStatus[keyof typeof USimStatus];

export const USimStatusLabel: Record<USimStatusValue, string> = {
  [USimStatus.PENDING_PROCESSING]: "Pending-Processing",
  [USimStatus.COMPLETE]: "Completed",
  [USimStatus.CANCELLED]: "Cancelled",
};

// Helpful for dropdowns or filters in the UI
export const USimStatusOptions = Object.entries(USimStatusLabel).map(([value, label]) => ({
  value: value as USimStatusValue,
  label,
}));

// Internal mapping for robust parsing. We strip spaces and hyphens before checking.
const ParsingMap: Record<string, USimStatusValue> = {
  "10": USimStatus.PENDING_PROCESSING,
  "PENDINGACTIVATION": USimStatus.PENDING_PROCESSING,
  "PENDINGRECHARGE": USimStatus.PENDING_PROCESSING,
  "PENDINGPROCESSING": USimStatus.PENDING_PROCESSING,

  "20": USimStatus.COMPLETE,
  "COMPLETE": USimStatus.COMPLETE,
  "COMPLETED": USimStatus.COMPLETE,

  "30": USimStatus.CANCELLED,
  "CANCELLED": USimStatus.CANCELLED,
  "CANCELLLED": USimStatus.CANCELLED, // keeping previous typo handler for safety
};

/**
 * Normalizes any string/number into the official backend string code (e.g., "10", "20").
 * This is useful before sending data to the API.
 */
export function toUSimStatus(status: string | number | undefined | null): USimStatusValue {
  if (status == null) return USimStatus.PENDING_PROCESSING;
  const normalized = String(status).toUpperCase().replace(/[\s-]+/g, "");
  return ParsingMap[normalized] || USimStatus.PENDING_PROCESSING;
}

/**
 * Converts a status code or label into the official frontend display string (e.g., "Pending-Processing").
 * Useful for tables and order details.
 */
export function fromUSimStatus(status: string | number | undefined | null): string {
  const safeStatusCode = toUSimStatus(status);
  return USimStatusLabel[safeStatusCode];
}